import PropTypes from "prop-types";
import React, { useEffect, useRef } from "react";

// //Import Scrollbar
import SimpleBar from "simplebar-react";

// MetisMenu
import MetisMenu from "metismenujs";
import { Link, useLocation } from "react-router-dom";
import withRouter from "../Common/withRouter";

//i18n
import { withTranslation } from "react-i18next";
import { useCallback } from "react";

const SidebarContent = (props) => {
  const ref = useRef();
  const path = useLocation();

  const activateParentDropdown = useCallback((item) => {
    item.classList.add("active");
    const parent = item.parentElement;
    const parent2El = parent.childNodes[1];
    if (parent2El && parent2El.id !== "side-menu") {
      parent2El.classList.add("mm-show");
    }

    if (parent) {
      parent.classList.add("mm-active");
      const parent2 = parent.parentElement;

      if (parent2) {
        parent2.classList.add("mm-show"); // ul tag

        const parent3 = parent2.parentElement; // li tag

        if (parent3) {
          parent3.classList.add("mm-active"); // li
          parent3.childNodes[0].classList.add("mm-active"); //a
          const parent4 = parent3.parentElement; // ul
          if (parent4) {
            parent4.classList.add("mm-show"); // ul
            const parent5 = parent4.parentElement;
            if (parent5) {
              parent5.classList.add("mm-show"); // li
              parent5.childNodes[0].classList.add("mm-active"); // a tag
            }
          }
        }
      }
      scrollElement(item);
      return false;
    }
    scrollElement(item);
    return false;
  }, []);

  const removeActivation = (items) => {
    for (var i = 0; i < items.length; ++i) {
      var item = items[i];
      const parent = items[i].parentElement;

      if (item && item.classList.contains("active")) {
        item.classList.remove("active");
      }
      if (parent) {
        const parent2El =
          parent.childNodes && parent.childNodes.lenght && parent.childNodes[1]
            ? parent.childNodes[1]
            : null;
        if (parent2El && parent2El.id !== "side-menu") {
          parent2El.classList.remove("mm-show");
        }

        parent.classList.remove("mm-active");
        const parent2 = parent.parentElement;

        if (parent2) {
          parent2.classList.remove("mm-show");

          const parent3 = parent2.parentElement;
          if (parent3) {
            parent3.classList.remove("mm-active"); // li
            parent3.childNodes[0].classList.remove("mm-active");

            const parent4 = parent3.parentElement; // ul
            if (parent4) {
              parent4.classList.remove("mm-show"); // ul
              const parent5 = parent4.parentElement;
              if (parent5) {
                parent5.classList.remove("mm-show"); // li
                parent5.childNodes[0].classList.remove("mm-active"); // a tag
              }
            }
          }
        }
      }
    }
  };

  const activeMenu = useCallback(() => {
    const pathName = path.pathname;
    let matchingMenuItem = null;
    const ul = document.getElementById("side-menu");
    const items = ul.getElementsByTagName("a");
    removeActivation(items);

    for (let i = 0; i < items.length; ++i) {
      if (pathName === items[i].pathname) {
        matchingMenuItem = items[i];
        break;
      }
    }
    if (matchingMenuItem) {
      activateParentDropdown(matchingMenuItem);
    }
  }, [path.pathname, activateParentDropdown]);

  useEffect(() => {
    ref.current.recalculate();
  }, []);

  useEffect(() => {
    new MetisMenu("#side-menu");
    activeMenu();
  }, []);

  useEffect(() => {
    window.scrollTo({ top: 0, behavior: "smooth" });
    activeMenu();
  }, [activeMenu]);

  function scrollElement(item) {
    if (item) {
      const currentPosition = item.offsetTop;
      if (currentPosition > window.innerHeight) {
        ref.current.getScrollElement().scrollTop = currentPosition - 300;
      }
    }
  }

  return (
    <React.Fragment>
      <SimpleBar className="h-100" ref={ref}>
        <div id="sidebar-menu">
          <ul className="metismenu list-unstyled" id="side-menu">
            <li className="menu-title">{props.t("KirayaGo Admin Portal")}</li>

            {/* 1. Dashboard */}
            <li>
              <Link to="/dashboard">
                <i className="bx bx-home-circle"></i>
                <span>{props.t("Dashboard")}</span>
              </Link>
            </li>

            {/* 2. Operations & Dispatch */}
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-navigation"></i>
                <span>{props.t("Operations & Dispatch")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/AssignDriver">{props.t("Live Dispatch / Assign")}</Link>
                </li>
                <li>
                  <Link to="/LiveTripTracking">
                    <span className="badge rounded-pill bg-success float-end">Live</span>
                    <span>{props.t("Live Trip Tracking")}</span>
                  </Link>
                </li>
                <li>
                  <Link to="/DriverForApproval">{props.t("Driver Approvals")}</Link>
                </li>
                <li>
                  <Link to="/WithdrawalRequests">{props.t("Withdrawal Requests")}</Link>
                </li>
                <li>
                  <Link to="/WalletTopup">{props.t("Wallet Topup")}</Link>
                </li>
              </ul>
            </li>

            {/* 3. Fleet & Members */}
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-car"></i>
                <span>{props.t("Fleet & Members")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/MemberMaster">{props.t("Member Master (Captains & Users)")}</Link>
                </li>
                <li>
                  <Link to="/VehicleMaster">{props.t("Vehicle Master")}</Link>
                </li>
                <li>
                  <Link to="/VehicleTypeMaster">{props.t("Vehicle Type Master")}</Link>
                </li>
                <li>
                  <Link to="/VehicleCategoryMaster">{props.t("Vehicle Category Master")}</Link>
                </li>
                <li>
                  <Link to="/GoodsTypeMaster">{props.t("Goods Type Master (Cargo)")}</Link>
                </li>
              </ul>
            </li>

            {/* 4. Tariff & Commercials */}
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-purchase-tag-alt"></i>
                <span>{props.t("Tariff & Commercials")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/RateMaster">{props.t("Rate Master (Distance Slabs)")}</Link>
                </li>
                <li>
                  <Link to="/VehicleRateMaster">{props.t("Vehicle Rate Master")}</Link>
                </li>
                <li>
                  <Link to="/VehicleTypeInstructionMaster">{props.t("Vehicle Instructions")}</Link>
                </li>
                <li>
                  <Link to="/CommissionMaster">{props.t("Commission Master")}</Link>
                </li>
                <li>
                  <Link to="/ChargeTypeMaster">{props.t("Additional Charges")}</Link>
                </li>
                <li>
                  <Link to="/CouponMaster">{props.t("Coupon & Promo Codes")}</Link>
                </li>
              </ul>
            </li>

            {/* 5. Finance & Accounts */}
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-calculator"></i>
                <span>{props.t("Finance & Reports")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/VoucherEntry">{props.t("Voucher Entry (Journal)")}</Link>
                </li>
                <li>
                  <Link to="/WalletTopup">{props.t("Wallet Topup Voucher")}</Link>
                </li>
                <li>
                  <Link to="/LedgerReport">{props.t("Ledger Statement")}</Link>
                </li>
                <li>
                  <Link to="/ProfitLossReport">{props.t("Profit & Loss (P&L)")}</Link>
                </li>
                <li>
                  <Link to="/BalanceSheet">{props.t("Balance Sheet")}</Link>
                </li>
              </ul>
            </li>

            {/* 6. Notifications & Marketing */}
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-broadcast"></i>
                <span>{props.t("Notifications & Marketing")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/SendNotification">{props.t("Send Custom Notification")}</Link>
                </li>
                <li>
                  <Link to="/NotificationHistory">{props.t("Campaign History & Logs")}</Link>
                </li>
              </ul>
            </li>

            {/* 7. System & Setup */}
            <li>
              <Link to="/#" className="has-arrow">
                <i className="bx bx-slider-alt"></i>
                <span>{props.t("System Setup")}</span>
              </Link>
              <ul className="sub-menu" aria-expanded="false">
                <li>
                  <Link to="/UserMaster">{props.t("System Users & Roles")}</Link>
                </li>
                <li>
                  <Link to="/CityMaster">{props.t("City Master")}</Link>
                </li>
                <li>
                  <Link to="/AreaZoneMaster">{props.t("Geofence & Zones")}</Link>
                </li>
                <li>
                  <Link to="/StateMaster">{props.t("State Master")}</Link>
                </li>
                <li>
                  <Link to="/UpdateGlobalOptions">{props.t("Global Options & Settings")}</Link>
                </li>
              </ul>
            </li>
          </ul>
        </div>
      </SimpleBar>
    </React.Fragment>
  );
};

SidebarContent.propTypes = {
  location: PropTypes.object,
  t: PropTypes.any,
};

export default withRouter(withTranslation()(SidebarContent));
